import React from 'react';
import { gameTimerModeNames } from '../../env';
import Button from '../Utils/Button';

export default class PlayerBotRoomRow extends React.Component
{
  formatTimeAgo = ( dateString ) =>
  {
    const now = new Date();
    const created = new Date( dateString );
    const diffMs = now - created;
    const diffMins = Math.floor( diffMs / ( 1000 * 60 ) );
    const diffHours = Math.floor( diffMins / 60 );
    const diffDays = Math.floor( diffHours / 24 );

    if( diffMins < 1 ) return 'Just now';
    if( diffMins < 60 ) return `${diffMins}m ago`;
    if( diffHours < 24 ) return `${diffHours}h ago`;
    return `${diffDays}d ago`;
  }

  getPlayerBotNames = ( playerBots ) =>
  {
    if( !playerBots || playerBots.length === 0 ) return 'None';
    return playerBots.join( ', ' );
  }

  handleViewRoom = () =>
  {
    const { room } = this.props;
    // This would typically navigate to a room detail page
    console.log( 'View room:', room.roomId );
  }

  render()
  {
    const { room, index } = this.props;
    const isEvenRow = index % 2 === 0;

    return (
      <div className={ `table-row ${isEvenRow ? 'row-even' : 'row-odd'}` }>
        <div className="col-room-id">
          <span className="room-id-link" onClick={ this.handleViewRoom }>
            { room.roomId }
          </span>
        </div>

        <div className="col-status">
          <span className={ `status-badge ${room.started ? 'status-progress' : 'status-waiting'}` }>
            { room.started ? 'In Progress' : 'Waiting' }
          </span>
        </div>

        <div className="col-players">
          <div className="player-count-container">
            <span className="player-count">{ room.players }/{ room.maxPlayers }</span>
            <div className="player-progress-bar">
              <div
                className="player-progress-fill"
                style={ { width: `${( room.players / room.maxPlayers ) * 100}%` } }
              ></div>
            </div>
          </div>
        </div>

        <div className="col-playerbots">
          <div className="playerbot-info">
            <span className="playerbot-count">
              { room.playerBotUsernames ? room.playerBotUsernames.length : 0 }
            </span>
            <div className="playerbot-names" title={ this.getPlayerBotNames( room.playerBotUsernames ) }>
              { this.getPlayerBotNames( room.playerBotUsernames ) }
            </div>
          </div>
        </div>

        <div className="col-speed">
          <span className={ `speed-badge speed-${room.gameTimer}` }>
            { gameTimerModeNames[ room.gameTimer ] || 'Unknown' }
          </span>
        </div>

        <div className="col-created">
          <span className="time-ago">{ this.formatTimeAgo( room.createdAt ) }</span>
        </div>

        <div className="col-actions">
          <Button
            className="view-room-button"
            onClick={ this.handleViewRoom }
          >
            View Room
          </Button>
        </div>
      </div>
    );
  }
}
